<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Klienci</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/clients/list">Klienci</router-link>
        </li>
        <li class="active">
          <strong>Szczegóły</strong>
        </li>
      </ol>
    </div>
  </div>

  <div
    class="wrapper wrapper-content animated fadeInRight client-details-container"
  >
    <div class="row">
      <div class="col-lg-12">
        <div
          v-if="!clientObj?.user?.is_active && canChangeClient"
          class="ibox float-e-margins"
        >
          <button @click="activateClient" class="btn btn-primary">
            <span class="fa fa-check"></span>
            <span>Aktywuj</span>
          </button>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Dane klienta</h5>
          </div>
          <div class="ibox-content panel">
            <div v-if="clientObj.user" class="panel-body">
              <dl class="dl-horizontal">
                <dt>Imię</dt>
                <dd>
                  {{
                    clientObj.user.first_name + " " + clientObj.user.last_name
                  }}
                </dd>
                <dt>Adres e-mail</dt>
                <dd>{{ clientObj.user.email }}</dd>
                <dt>Metoda płatności</dt>
                <dd>{{ clientObj.payment_method ?? "-" }}</dd>
                <dt>Sklep</dt>
                <dd>{{ clientObj.company_localization_display ?? "-" }}</dd>
              </dl>
              <div class="hr-line-dashed"></div>
              <dl class="dl-horizontal">
                <dt>Nazwa firmy</dt>
                <dd>{{ clientObj.company_name ?? "-" }}</dd>
                <dt>NIP</dt>
                <dd>{{ clientObj.tax_id ?? "-" }}</dd>
                <dt>Numer telefonu</dt>
                <dd>{{ clientObj.telephone ?? "-" }}</dd>
                <dt>Adres</dt>
                <dd>{{ clientObj.address ?? "-" }}</dd>
                <dt>Numer budynku</dt>
                <dd>{{ clientObj.building_number ?? "-" }}</dd>
                <dt>Numer mieszkania</dt>
                <dd>{{ clientObj.suite_number ?? "-" }}</dd>
                <dt>Miasto</dt>
                <dd>{{ clientObj.city ?? "-" }}</dd>
                <dt>Kod pocztowy</dt>
                <dd>{{ clientObj.zip_code ?? "-" }}</dd>
                <dt>Kraj</dt>
                <dd>{{ clientObj.country ?? "-" }}</dd>
              </dl>
              <div class="hr-line-dashed"></div>
              <dl class="dl-horizontal">
                <dt>Grupa rabatowa</dt>
                <dd>{{ clientObj.discount_group ?? "-" }}</dd>
                <dt>Główne konto</dt>
                <dd>{{ clientObj.main_account_name ?? "-" }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Dodatkowy adres dostawy</h5>
          </div>
          <div class="ibox-content panel">
            <dl class="dl-horizontal">
              <dt>Nazwa firmy</dt>
              <dd>{{ clientObj.company_name_2 ?? "-" }}</dd>
              <dt>NIP</dt>
              <dd>{{ clientObj.tax_id_2 ?? "-" }}</dd>
              <dt>Numer telefonu</dt>
              <dd>{{ clientObj.telephone_2 ?? "-" }}</dd>
              <dt>Adres</dt>
              <dd>{{ clientObj.address_2 ?? "-" }}</dd>
              <dt>Numer budynku</dt>
              <dd>{{ clientObj.building_number_2 ?? "-" }}</dd>
              <dt>Numer mieszkania</dt>
              <dd>{{ clientObj.suite_number_2 ?? "-" }}</dd>
              <dt>Miasto</dt>
              <dd>{{ clientObj.city_2 ?? "-" }}</dd>
              <dt>Kod pocztowy</dt>
              <dd>{{ clientObj.zip_code_2 ?? "-" }}</dd>
              <dt>Kraj</dt>
              <dd>{{ clientObj.country ?? "-" }}</dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Zamówienia</h5>
          </div>
          <div
            v-if="clientOrdersData?.data?.results.length > 0"
            class="ibox-content"
          >
            <!-- Activity Summary Widget above the table -->
            <div class="table-summary">
              <!-- Column labels row -->
              <div class="row summary-labels">
                <div class="col-md-2">
                  <strong>Podsumowanie:</strong>
                </div>
                <div class="col-md-1">
                  <strong>Liczba zamówień</strong>
                </div>
                <div class="col-md-1">
                  <strong>Suma netto</strong>
                </div>
                <div class="col-md-1">
                  <strong>Suma netto produkty</strong>
                </div>
                <div class="col-md-1">
                  <strong>Suma netto wysyłka</strong>
                </div>
                <div class="col-md-1">
                  <strong>Średnia VAT %</strong>
                </div>
                <div class="col-md-1">
                  <strong>Suma VAT</strong>
                </div>
                <div class="col-md-1">
                  <strong>Suma adresów</strong>
                </div>
                <div class="col-md-1">
                  <strong>Suma paczek</strong>
                </div>
              </div>
              <!-- Values row -->
              <div class="row summary-values">
                <div class="col-md-2">
                  <span class="text-muted">Wartości:</span>
                </div>
                <div class="col-md-1">
                  <strong>{{ clientOrdersData.data.results.length }}</strong>
                </div>
                <div class="col-md-1">
                  <strong>
                    {{ formatCurrency(ordersSummary.final_net_price) }}
                  </strong>
                </div>
                <div class="col-md-1">
                  <strong>
                    {{ formatCurrency(ordersSummary.products_net_price) }}
                  </strong>
                </div>
                <div class="col-md-1">
                  <strong>
                    {{ formatCurrency(ordersSummary.delivery_price) }}
                  </strong>
                </div>
                <div class="col-md-1">
                  <strong>{{ ordersSummary.avg_vat_percent }}%</strong>
                </div>
                <div class="col-md-1">
                  <strong>{{ formatCurrency(ordersSummary.vat_price) }}</strong>
                </div>
                <div class="col-md-1">
                  <strong>{{ ordersSummary.total_addresses }}</strong>
                </div>
                <div class="col-md-1">
                  <strong>{{ ordersSummary.total_packages }}</strong>
                </div>
              </div>
            </div>

            <!-- Pagination above the table -->
            <div class="pagination" v-if="totalOrdersCount">
              <span class="items-all">
                Ilość rekordów: <b>{{ totalOrdersCount }}</b>
              </span>
              <span>
                Ilość na stronę:
                <select v-model="serverLogsOptions.rowsPerPage">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </span>
              <span>
                <input type="number" v-model="serverLogsOptions.page" /> -
                {{
                  Math.ceil(totalOrdersCount / serverLogsOptions.rowsPerPage)
                }}
              </span>
              <button @click="selectPage(1)" class="btn btn-primary ml-25">
                Pierwsza
              </button>
              <button
                @click="serverLogsOptions.page = serverLogsOptions.page - 1"
                :disabled="serverLogsOptions.page === 1"
                class="prev nl"
              ></button>
              <button
                @click="serverLogsOptions.page = serverLogsOptions.page + 1"
                :disabled="
                  serverLogsOptions.page ===
                  Math.ceil(totalOrdersCount / serverLogsOptions.rowsPerPage)
                "
                class="next"
              ></button>
              <button
                @click="
                  selectPage(
                    Math.ceil(totalOrdersCount / serverLogsOptions.rowsPerPage)
                  )
                "
                class="btn btn-primary"
              >
                Ostatnia
              </button>
            </div>

            <!-- Shared horizontal scroll container for table + summary -->
            <div
              class="orders-scroll-container"
              v-if="clientOrdersData?.data?.results.length > 0"
            >
              <EasyDataTable
                ref="ordersTableRef"
                v-model:server-options="serverLogsOptions"
                :server-items-length="totalOrdersCount"
                :headers="ordersHeaders"
                :items="ordersItemsWithSummary"
                :clickRowToExpand="false"
                @click-row="goToOrder"
                :loading="loading"
                :body-row-class-name="bodyRowClassNameFunction"
                alternating
                show-index
                multi-sort
                border-cell
              >
              </EasyDataTable>
            </div>

            <!-- Pagination below the table -->
            <div class="pagination" v-if="totalOrdersCount">
              <span class="items-all">
                Ilość rekordów: <b>{{ totalOrdersCount }}</b>
              </span>
              <span>
                Ilość na stronę:
                <select v-model="serverLogsOptions.rowsPerPage">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </span>
              <span>
                <input type="number" v-model="serverLogsOptions.page" /> -
                {{
                  Math.ceil(totalOrdersCount / serverLogsOptions.rowsPerPage)
                }}
              </span>
              <button @click="selectPage(1)" class="btn btn-primary ml-25">
                Pierwsza
              </button>
              <button
                @click="serverLogsOptions.page = serverLogsOptions.page - 1"
                :disabled="serverLogsOptions.page === 1"
                class="prev nl"
              ></button>
              <button
                @click="serverLogsOptions.page = serverLogsOptions.page + 1"
                :disabled="
                  serverLogsOptions.page ===
                  Math.ceil(totalOrdersCount / serverLogsOptions.rowsPerPage)
                "
                class="next"
              ></button>
              <button
                @click="
                  selectPage(
                    Math.ceil(totalOrdersCount / serverLogsOptions.rowsPerPage)
                  )
                "
                class="btn btn-primary"
              >
                Ostatnia
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Faktury</h5>
          </div>
          <div
            v-if="clientInvoicesData?.data?.results.length > 0"
            class="ibox-content"
          >
            <EasyDataTable
              v-model:server-options="serverLogsOptions"
              :server-items-length="clientInvoicesData.data.results.length"
              :headers="invoicesHeaders"
              :items="clientInvoicesData.data.results"
              :clickRowToExpand="false"
              :loading="loading"
              alternating
              show-index
              multi-sort
              border-cell
            >
            </EasyDataTable>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Sprawy</h5>
          </div>
          <div
            v-if="clientMessagesData?.data?.results.length > 0"
            class="ibox-content"
          >
            <EasyDataTable
              v-model:server-options="serverLogsOptions1"
              :server-items-length="clientMessagesData.data.results.length"
              :headers="messagesHeaders"
              :items="clientMessagesData.data.results"
              @click-row="goToMessage"
              :clickRowToExpand="false"
              :loading="loading"
              alternating
              show-index
              multi-sort
              border-cell
            >
            </EasyDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import router from "../../router/router";
import { hasPermission } from "../../permissions";
import { clientPermissionsConst } from "../../constants/clientConstants";

export default {
  name: "ClientsDetails",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const errorsAdminData = ref();
    const showErrors = ref(false);
    const store = useStore();
    // Activating an account writes to the client - the same permission the
    // edit form requires.
    const canChangeClient = computed(() =>
      hasPermission(clientPermissionsConst.update)
    );
    const clientOrdersData = computed(() => store.getters.getClientOrdersData);
    const clientInvoicesData = computed(
      () => store.getters.getClientInvoicesData
    );
    const clientMessagesData = computed(
      () => store.getters.getClientMessagesData
    );
    const clientData = computed(() => store.getters.getClientData);
    const updateClientData = computed(() => store.getters.getUpdateClientData);
    let items = ref([]);
    const loading = ref(true);
    const clientObj = ref({});
    let itemsAll = ref(0);
    const route = useRoute();
    const searchValue = ref({});
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });
    const serverLogsOptions = ref({
      page: 1,
      rowsPerPage: 25,
      sortBy: null,
      sortType: "asc",
    });
    const serverOptions1 = ref({
      page: 1,
      rowsPerPage: 25,
    });
    let messagesHeaders = [
      {
        text: "Nr sprawy",
        value: "pk",
        sortable: true,
        search: true,
      },
      {
        text: "E-mail",
        value: "client_email",
        sortable: true,
        search: true,
      },
      {
        text: "Klient",
        value: "client_name",
        sortable: true,
        search: true,
      },
      {
        text: "Rodzaj sprawy",
        value: "competency",
        sortable: true,
        search: true,
      },
      {
        text: "Osoba odpowiedzialna",
        value: "responsible_person_name",
        sortable: true,
        search: true,
      },
      {
        text: "Status",
        value: "status_display",
        sortable: true,
        search: true,
      },
    ];

    let ordersHeaders = [
      {
        text: "Nr zamówienia",
        value: "pk",
        sortable: true,
        search: true,
      },
      {
        text: "E-mail",
        value: "client_email",
        sortable: true,
        search: true,
      },
      {
        text: "Klient",
        value: "client_name",
        sortable: true,
        search: true,
      },
      {
        text: "Sklep",
        value: "company_localization_display",
        sortable: true,
      },
      {
        text: "Język",
        value: "lang_display",
        sortable: true,
        search: true,
      },
      {
        text: "Waluta",
        value: "currency",
        sortable: true,
        search: true,
      },
      {
        text: "Netto",
        value: "final_net_price_",
        sortable: true,
        search: true,
      },
      {
        text: "Netto produkty",
        value: "products_net_price_",
        sortable: true,
        search: true,
      },
      {
        text: "Netto wysyłka",
        value: "delivery_price_",
        sortable: true,
        search: true,
      },
      {
        text: "Stawka VAT",
        value: "vat_percent_",
        sortable: true,
        search: true,
      },
      {
        text: "Wartość VAT",
        value: "vat_price_",
        sortable: true,
        search: true,
      },
      {
        text: "Liczba adresów",
        value: "adresses_count_",
        sortable: true,
        search: true,
      },
      {
        text: "Liczba paczek",
        value: "delivery_packages_",
        sortable: true,
        search: true,
      },
      {
        text: "Metoda płatności",
        value: "payment_method_display",
        sortable: true,
        search: true,
      },
      {
        text: "Status zamówienia",
        value: "status_display",
        sortable: true,
        search: true,
      },
      {
        text: "Termin",
        value: "realization_date",
        sortable: true,
        search: true,
      },
    ];

    let invoicesHeaders = [
      {
        text: "Nr faktury",
        value: "number",
        sortable: true,
        search: true,
      },
      {
        text: "Nr zamówienia",
        value: "order",
        sortable: true,
        search: true,
      },
      {
        text: "Nazwa firmy",
        value: "company_name",
        sortable: true,
        search: false,
      },
      {
        text: "Sklep",
        value: "company_localization_display",
        sortable: true,
      },
      {
        text: "Język",
        value: "lang_display",
        sortable: true,
        search: true,
      },
      {
        text: "Waluta",
        value: "currency",
        sortable: true,
        search: true,
      },
      {
        text: "Netto",
        value: "net_price",
        sortable: true,
        search: true,
      },
      {
        text: "VAT",
        value: "vat",
        sortable: true,
        search: true,
      },
      {
        text: "Brutto",
        value: "gross_price",
        sortable: false,
        search: false,
      },
      {
        text: "Rodzaj faktury",
        value: "invoice_type_display",
        sortable: false,
        search: false,
      },
      {
        text: "Data wystawienia",
        value: "issue_date",
        sortable: true,
        search: true,
      },
    ];

    const getClientOrders = () => {
      loading.value = true;
      let sort;
      if (serverLogsOptions.value.sortType === "desc") {
        sort = "-" + serverLogsOptions.value.sortBy;
      } else {
        sort = serverLogsOptions.value.sortBy;
      }

      /* debug removed */

      store.dispatch("getClientOrders", {
        client_pk: route.params?.pk,
        page: serverLogsOptions.value.page,
        itemsPerPage: serverLogsOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const getClientMessages = () => {
      loading.value = true;
      let sort;
      if (serverOptions1.value.sortType === "desc") {
        sort = "-" + serverOptions1.value.sortBy;
      } else {
        sort = serverOptions1.value.sortBy;
      }
      store.dispatch("getClientMessages", {
        client_pk: route.params?.pk,
        page: serverOptions1.value.page,
        itemsPerPage: serverOptions1.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const getClientInvoices = () => {
      loading.value = true;
      let sort;
      if (serverOptions1.value.sortType === "desc") {
        sort = "-" + serverOptions1.value.sortBy;
      } else {
        sort = serverOptions1.value.sortBy;
      }
      store.dispatch("getClientInvoices", {
        client_pk: route.params?.pk,
        page: serverOptions1.value.page,
        itemsPerPage: serverOptions1.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const activateClient = () => {
      if (!canChangeClient.value) {
        return;
      }
      store.dispatch("updateClient", {
        pk: route.params?.pk,
        user: {
          is_active: true,
        },
      });
    };

    const goToMessage = (item) => {
      router.push({
        name: "MessagesDetails",
        path: "/messages/details/",
        params: { pk: item.pk },
      });
    };

    const goToOrder = (item) => {
      let pk;
      if (typeof item.pk === "string") {
        pk = item.pk.match(/^\d+/)?.[0];
      } else {
        pk = item.pk;
      }
      router.push({
        name: "OrderDetails",
        path: "/order/details/",
        params: { pk: pk },
      });
    };

    const selectPage = (page) => {
      serverLogsOptions.value.page = page;
    };

    const ordersTableRef = ref(null);
    const summaryTableRef = ref(null);

    // Small retry helper to ensure alignment happens after render
    const tryAlignSummary = (attempts = 15, delayMs = 120) => {
      const didAlign = alignSummaryColumnsSafely();
      if (!didAlign && attempts > 0) {
        setTimeout(() => tryAlignSummary(attempts - 1, delayMs), delayMs);
      }
    };

    // Safe wrapper returns true if alignment completed
    const alignSummaryColumnsSafely = () => {
      let success = false;
      nextTick(() => {
        setTimeout(() => {
          const mainTable =
            ordersTableRef.value?.$el ||
            document.querySelector(".easy-data-table");
          const actualTable = mainTable?.querySelector("table");
          const tbody = actualTable?.querySelector("tbody");
          const summaryTable =
            summaryTableRef.value || document.querySelector(".summary-table");
          const summaryRowEl = summaryTable?.querySelector("tbody tr");
          const summaryCellsEls = summaryRowEl
            ? summaryRowEl.querySelectorAll("td")
            : [];
          const dataRows = tbody
            ? Array.from(tbody.querySelectorAll("tr")).filter(
                (r) => !r.classList.contains("table-summary-row")
              )
            : [];

          if (!summaryCellsEls.length || !dataRows.length) return;

          const lastDataRow = dataRows[dataRows.length - 1];
          const dataCells = lastDataRow.querySelectorAll("td");
          const commonCount = Math.min(
            dataCells.length,
            summaryCellsEls.length
          );
          if (commonCount === 0) return;
          /* debug removed */

          // widths + clear
          for (let idx = 0; idx < commonCount; idx += 1) {
            const cell = summaryCellsEls[idx];
            const rect = dataCells[idx].getBoundingClientRect();
            const width = rect.width || dataCells[idx].offsetWidth || 0;
            const styleStr = `width: ${width}px; min-width: ${width}px; max-width: ${width}px;`;
            cell.style.width = `${width}px`;
            cell.style.minWidth = `${width}px`;
            cell.style.maxWidth = `${width}px`;
            cell.setAttribute("style", styleStr);
            cell.innerHTML = "";
          }
          // Clear any remaining extra cells (if any)
          for (let idx = commonCount; idx < summaryCellsEls.length; idx += 1) {
            summaryCellsEls[idx].innerHTML = "";
          }

          // totals
          const results = clientOrdersData.value?.data?.results || [];
          let finalNet = 0,
            productsNet = 0,
            delivery = 0,
            vatPercentSum = 0,
            vatPercentCount = 0,
            vatPrice = 0,
            addresses = 0,
            packagesCount = 0;
          results.forEach((order) => {
            if (order?.info?.final_net_price)
              finalNet += parseFloat(order.info.final_net_price) || 0;
            if (order?.info?.products_net_price)
              productsNet += parseFloat(order.info.products_net_price) || 0;
            if (order?.info?.delivery_price)
              delivery += parseFloat(order.info.delivery_price) || 0;
            if (order?.info?.vat_percent) {
              vatPercentSum += parseFloat(order.info.vat_percent) || 0;
              vatPercentCount += 1;
            }
            if (order?.info?.vat_price)
              vatPrice += parseFloat(order.info.vat_price) || 0;
            if (order?.adresses_count)
              addresses += parseInt(order.adresses_count) || 0;
            if (order?.info?.delivery_packages)
              packagesCount += parseInt(order.info.delivery_packages) || 0;
          });
          const avgVatPercent =
            vatPercentCount > 0
              ? (vatPercentSum / vatPercentCount).toFixed(1)
              : "0.0";
          const fmt = (val) =>
            isNaN(val) ? "0.00" : parseFloat(val).toFixed(2);

          // index mapping with show-index
          const COL_FINAL_NET = 7;
          const COL_PRODUCTS_NET = 8;
          const COL_DELIVERY = 9;
          const COL_VAT_PERCENT = 10;
          const COL_VAT_PRICE = 11;
          const COL_ADDRESSES = 12;
          const COL_PACKAGES = 13;

          const setStrong = (cell, value) => {
            if (!cell) return;
            const strong = document.createElement("strong");
            strong.textContent = value;
            cell.appendChild(strong);
          };
          setStrong(summaryCellsEls[COL_FINAL_NET], fmt(finalNet));
          setStrong(summaryCellsEls[COL_PRODUCTS_NET], fmt(productsNet));
          setStrong(summaryCellsEls[COL_DELIVERY], fmt(delivery));
          setStrong(summaryCellsEls[COL_VAT_PERCENT], `${avgVatPercent}%`);
          setStrong(summaryCellsEls[COL_VAT_PRICE], fmt(vatPrice));
          setStrong(summaryCellsEls[COL_ADDRESSES], `${addresses}`);
          setStrong(summaryCellsEls[COL_PACKAGES], `${packagesCount}`);

          // width match
          const tableWidth =
            actualTable?.getBoundingClientRect()?.width ||
            actualTable?.scrollWidth ||
            0;
          if (summaryTable && tableWidth)
            summaryTable.style.width = `${tableWidth}px`;
          success = true;
        }, 50);
      });
      return success;
    };

    // Replace previous single-call alignment with retry scheduler
    const alignSummaryColumns = () => {
      tryAlignSummary();
    };

    // Re-align on resize
    window.addEventListener("resize", () => tryAlignSummary(5, 150));

    // Helper function to format currency
    const formatCurrency = (value) => {
      if (!value || isNaN(value)) return "0.00";
      return parseFloat(value).toFixed(2);
    };

    // (Reverted) No appended summary in items; use external summary alignment

    // Computed properties for summary
    const ordersSummary = computed(() => {
      if (!clientOrdersData.value?.data?.results) return {};

      const orders = clientOrdersData.value.data.results;
      let summary = {
        final_net_price: 0,
        products_net_price: 0,
        delivery_price: 0,
        vat_percent: 0,
        vat_price: 0,
        total_addresses: 0,
        total_packages: 0,
        vat_percent_count: 0,
      };

      orders.forEach((order) => {
        if (order.info?.final_net_price) {
          summary.final_net_price +=
            parseFloat(order.info.final_net_price) || 0;
        }
        if (order.info?.products_net_price) {
          summary.products_net_price +=
            parseFloat(order.info.products_net_price) || 0;
        }
        if (order.info?.delivery_price) {
          summary.delivery_price += parseFloat(order.info.delivery_price) || 0;
        }
        if (order.info?.vat_percent) {
          summary.vat_percent += parseFloat(order.info.vat_percent) || 0;
          summary.vat_percent_count++;
        }
        if (order.info?.vat_price) {
          summary.vat_price += parseFloat(order.info.vat_price) || 0;
        }
        if (order.adresses_count) {
          summary.total_addresses += parseInt(order.adresses_count) || 0;
        }
        if (order.info?.delivery_packages) {
          summary.total_packages += parseInt(order.info.delivery_packages) || 0;
        }
      });

      summary.avg_vat_percent =
        summary.vat_percent_count > 0
          ? (summary.vat_percent / summary.vat_percent_count).toFixed(1)
          : "0.0";

      return summary;
    });

    // Computed property for total orders count
    const totalOrdersCount = computed(() => {
      const count = clientOrdersData.value?.data?.count || 0;
      /* debug removed */
      return count;
    });

    // Append summary row to items (display-only)
    const ordersItemsWithSummary = computed(() => {
      const base = clientOrdersData.value?.data?.results || [];
      if (!base.length) return base;
      const items = base.map((o) => ({
        ...o,
        final_net_price_: o?.info?.final_net_price,
        products_net_price_: o?.info?.products_net_price,
        delivery_price_: o?.info?.delivery_price,
        vat_percent_: o?.info?.vat_percent,
        vat_price_: o?.info?.vat_price,
        adresses_count_: o?.adresses_count,
        delivery_packages_: o?.info?.delivery_packages,
      }));
      const summary = {
        isSummary: true,
        pk: "",
        client_email: "",
        client_name: "",
        company_localization_display: "",
        lang_display: "",
        currency: "",
        final_net_price_: formatCurrency(ordersSummary.value.final_net_price),
        products_net_price_: formatCurrency(
          ordersSummary.value.products_net_price
        ),
        delivery_price_: formatCurrency(ordersSummary.value.delivery_price),
        vat_percent_: `${ordersSummary.value.avg_vat_percent}%`,
        vat_price_: formatCurrency(ordersSummary.value.vat_price),
        adresses_count_: `${ordersSummary.value.total_addresses}`,
        delivery_packages_: `${ordersSummary.value.total_packages}`,
        payment_method_display: "",
        status_display: "",
        realization_date: "",
      };
      items.push(summary);
      return items;
    });

    store.dispatch("getClient", { pk: route.params?.pk });
    getClientOrders();
    getClientMessages();
    getClientInvoices();

    watch(
      () => serverLogsOptions.value,
      function () {
        getClientOrders();
      }
    );

    watch(
      () => serverLogsOptions.value.rowsPerPage,
      function () {
        // Reset to first page when rows per page changes
        serverLogsOptions.value.page = 1;
        getClientOrders();
      }
    );

    watch(
      () => searchValue.value,
      function () {
        // Reset to first page when search changes
        serverLogsOptions.value.page = 1;
        getClientOrders();
      },
      { deep: true }
    );

    watch(
      () => serverOptions1.value,
      function () {
        getClientMessages();
      }
    );

    watch(
      () => updateClientData.value,
      function () {
        store.dispatch("getClient", { pk: route.params?.pk });
        store.dispatch("showToaster", {
          type: "success",
          content: "Konto klienta zostało pomyslnie aktywowane!",
        });
      }
    );

    watch(
      () => clientData.value,
      function (newValue) {
        clientObj.value = newValue.data;
      }
    );

    watch(
      () => clientOrdersData.value,
      function (newValue) {
        loading.value = false;
        if (newValue && newValue.data && newValue.data.results) {
          // Align summary columns after data loads
          alignSummaryColumns();
        }
      }
    );

    // Watch for search value changes
    watch(
      () => searchValue.value,
      () => {
        serverLogsOptions.value.page = 1;
        getClientOrders();
      }
    );

    // Watch for rows per page changes
    watch(
      () => serverLogsOptions.value.rowsPerPage,
      () => {
        serverLogsOptions.value.page = 1;
        getClientOrders();
      }
    );

    // Watch for sorting changes
    watch(
      () => [serverLogsOptions.value.sortBy, serverLogsOptions.value.sortType],
      () => {
        getClientOrders();
      }
    );

    // Component lifecycle
    onMounted(() => {
      getClientOrders();
      // Align summary columns after component mounts
      nextTick(() => {
        alignSummaryColumns();
      });
    });

    const bodyRowClassNameFunction = (row) => {
      if (row && row.isSummary) return "table-summary-row";
      return false;
    };

    return {
      errorsAdminData,
      showErrors,
      ordersHeaders,
      messagesHeaders,
      invoicesHeaders,
      clientOrdersData,
      clientMessagesData,
      clientInvoicesData,
      itemsAll,
      items,
      loading,
      serverOptions,
      serverLogsOptions,
      serverOptions1,
      clientObj,
      searchValue,
      goToMessage,
      goToOrder,
      selectPage,
      activateClient,
      canChangeClient,
      formatCurrency,
      ordersSummary,
      totalOrdersCount,
      ordersItemsWithSummary,
      bodyRowClassNameFunction,
      alignSummaryColumns,
      ordersTableRef,
      summaryTableRef,
    };
  },
  computed: {},
};
</script>

<style scoped>
.table-summary {
  margin-top: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.summary-labels,
.summary-values {
  margin: 0;
  font-size: 14px;
}

.summary-labels .col-md-1,
.summary-labels .col-md-2,
.summary-values .col-md-1,
.summary-values .col-md-2 {
  padding: 8px;
  text-align: center;
  border-right: 1px solid #dee2e6;
}

.summary-labels .col-md-1:last-child,
.summary-labels .col-md-2:last-child,
.summary-values .col-md-1:last-child,
.summary-values .col-md-2:last-child {
  border-right: none;
}

.summary-labels strong {
  color: #495057;
  font-size: 12px;
}

.summary-values strong {
  color: #495057;
}

.summary-values .text-muted {
  color: #6c757d;
  font-size: 12px;
}

.summary-labels {
  border-bottom: 1px solid #dee2e6;
  background-color: #e9ecef;
}

/* Styles for table column summaries */
.table-summary-row {
  background-color: #f8f9fa !important;
  border-top: 2px solid #dee2e6;
  font-weight: bold;
}

.table-summary-row td {
  padding: 12px 8px;
  text-align: center;
  border-right: 1px solid #dee2e6;
}

.table-summary-row td:first-child {
  text-align: left;
  font-weight: bold;
  color: #495057;
}

.table-summary-row td:last-child {
  border-right: none;
}

/* Styles for the column summary using table structure */
.table-column-summary {
  margin-top: 0;
  margin-bottom: 15px;
  max-width: 100%;
  /* In Firefox, ensure the block renders and doesn't collapse */
  display: block;
  overflow: auto;
}

.summary-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  table-layout: fixed; /* Force fixed table layout */
  /* Firefox: ensure empty cells are still painted */
  empty-cells: show;
}

.summary-table td {
  padding: 8px 4px;
  text-align: center;
  border-right: 1px solid #dee2e6;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 40px;
  min-height: 40px; /* Ensure row remains visible in Firefox */
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word; /* Break long text */
}

.summary-table td:last-child {
  border-right: none;
}

/* Completely disable horizontal scrolling */
:deep(.easy-data-table) {
  overflow-x: hidden !important;
}

:deep(.easy-data-table .v-data-table__wrapper) {
  overflow-x: hidden !important;
}

:deep(.easy-data-table .v-data-table) {
  overflow-x: hidden !important;
}

:deep(.easy-data-table .v-data-table__wrapper table) {
  overflow-x: hidden !important;
}

/* Force the entire page to not have horizontal scroll */
body {
  overflow-x: hidden !important;
}

/* Ensure the main container doesn't scroll horizontally */
.client-details-container {
  overflow-x: hidden !important;
  max-width: 100vw !important;
}

/* Shared scroll container so scrollbar appears under summary */
.orders-scroll-container {
  overflow-x: auto;
  overflow-y: visible;
  width: 100%;
}

/* Ensure internal table and summary have min-content width so they scroll together */
.orders-scroll-container .easy-data-table,
.orders-scroll-container .summary-table {
  min-width: max-content;
}

/* Prevent internal components from creating their own horizontal scrollbars */
:deep(.orders-scroll-container .easy-data-table),
:deep(.orders-scroll-container .easy-data-table .v-data-table__wrapper),
:deep(.orders-scroll-container .easy-data-table .v-data-table) {
  overflow-x: visible !important;
}
</style>
